// extracted by mini-css-extract-plugin
export var localeSelector = "_69-0";